var _rect, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle4, _circle5, _ellipse, _ellipse2, _ellipse3, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle12, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#7ec3e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#8dcae9",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 64,
    r: 10,
    fill: "#f0c060"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 64,
    r: 10,
    fill: "#f0c060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 50C32 62 30 70 32 78M84 50C88 62 90 70 88 78",
    stroke: "#f0c060",
    strokeWidth: 7,
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#d9453a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 96L108 96",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 104L108 104",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 112L108 112",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 120L108 120",
    stroke: "#f4f1ea",
    strokeWidth: 3.2,
    opacity: 0.9
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 86C48 94 72 94 74 86",
    fill: "none",
    stroke: "#ad372e",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 61,
    r: 0.9,
    fill: "#9f8974"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 62.5,
    r: 0.9,
    fill: "#9f8974"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 63.5,
    r: 0.9,
    fill: "#9f8974"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55Q51 50 55 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55Q69 50 73 55",
    stroke: "#2a1d1a",
    strokeWidth: 2.4,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#c08a30",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#c08a30",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67Q60 78 69 67Z",
    fill: "#fff",
    stroke: "#2a1d1a",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50C35 29 48 22 60 22S85 29 82 50C78 41 71 35 60 35S42 41 38 50Z",
    fill: "#f0c060"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 46,
    r: 3.2,
    fill: "#e8564a"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 46,
    r: 3.2,
    fill: "#e8564a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait14);
export default __webpack_public_path__ + "static/media/player-portrait-14.c35036b8bd58539d3205e9b6d3f9bcff.svg";
export { ForwardRef as ReactComponent };